import { getCutPrice } from "../../../base/helpers/getCutPrice";

export const formatInputPrice = (value) => {
  return value ? getCutPrice(value) : null
}